module.exports = __webpack_public_path__ + "img/shouye-fuhua-png.185b0603.svg";